import React from "react";
import ReactDom from "react-dom";
import * as R from "ramda";
import UnitDetailPage from "./UnitDetailPage.jsx";

export default function renderUnitDetailPage() {
  document.querySelectorAll(".js-unit-detail-mount").forEach(mount => {
    const config = R.compose(
      JSON.parse,
      R.defaultTo("{}"),
    )(mount.getAttribute("data-config"));

    ReactDom.render(<UnitDetailPage {...config} />, mount);
  });
}
